import axios from "axios";
import uRLs from "../utils/baseUtils";

const AxiosInstance = axios.create({
    baseURL: uRLs.API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

let refreshPromise = null;

/** NEW: API activity tracking */
let lastApiHit = Date.now();
let idleInterval = null;
let isWarming = false;

/** helper to update last hit (also sync across tabs) */
const updateLastApiHit = () => {
    lastApiHit = Date.now();
    localStorage.setItem("lastApiHit", lastApiHit);
};
/** start idle watcher */
export const startApiIdleWatcher = (warmApiFn, timeout = 120000) => {
    if (idleInterval) return;

    idleInterval = setInterval(() => {
        const stored = localStorage.getItem("lastApiHit");
        if (stored) lastApiHit = Number(stored);

        const now = Date.now();

        if (!isWarming && now - lastApiHit > timeout) {
            isWarming = true;

            warmApiFn()
                .catch(() => {}) // ignore errors
                .finally(() => {
                    isWarming = false;
                    updateLastApiHit();
                });
        }
    }, 5000);
};

export const stopApiIdleWatcher = () => {
    if (idleInterval) {
        clearInterval(idleInterval);
        idleInterval = null;
    }
};

export const setupInterceptors = ({ handleGetToken, handleUpdateToken, handleLogout }) => {
    AxiosInstance.interceptors.request.use(
        async (config) => {
            try {

                updateLastApiHit();
                const tokenData = handleGetToken();
                if (tokenData?.accessStoreToken) {
                    config.headers.Authorization = `Bearer ${tokenData.accessStoreToken}`;
                }
                return config;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        (error) => Promise.reject(error)
    );

    AxiosInstance.interceptors.response.use(
        (response) => {
            /** track API hit */
            updateLastApiHit();
            return response
        },
        async (error) => {
             /**  track API hit even on failure */
             updateLastApiHit();
            const originalRequest = error.config;
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const tokenData = handleGetToken();
                    if (!tokenData?.refreshStoreToken) {
                        throw new Error("No refresh token available");
                    }
                    if (!refreshPromise) {
                        refreshPromise = refreshAccessToken(tokenData.refreshStoreToken, handleUpdateToken);
                    }
                    const newAccessToken = await refreshPromise;
                    refreshPromise = null;
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    return AxiosInstance(originalRequest);
                } catch (refreshError) {
                    refreshPromise = null;
                    if (refreshError.response?.status === 401 || refreshError.response?.status === 403 ) {
                        handleLogout();
                    }
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error);
        }
    );
};

const refreshAccessToken = async (refreshToken, handleUpdateToken) => {
    try {
        const response = await axios.get(`${uRLs.API_URL}create-token`, {
            headers: {
                Authorization: `Bearer ${refreshToken}`,
            },
        });
        const newAccessToken = response.data.results.accessToken; 
        handleUpdateToken(newAccessToken);
        return newAccessToken;
    } catch (error) {
        throw error;
    }
};

export default AxiosInstance;